import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Button, IconArrowRight as ArrowRight } from '../../core';

interface Props {
  className?: string;
  newsImage?: string;
  newsTitle?: string;
  newsDate?: string;
  newsContent?: string;
}

const LatestNews = ({
  className = '',
  newsImage = '',
  newsTitle = '',
  newsDate = '',
  newsContent = '',
}: Props) => {
  const navigate = useNavigate();

  return (
    <div className={className}>
      <div className="news-header">
        <h2>Latest Updates</h2>
      </div>
      <div className="news-body">
        <img src={newsImage} alt={newsTitle} />
        <div>
          <div className="news-content">
            <span className="news-date">{newsDate}</span>
            <h3 className="news-title">{newsTitle}</h3>
            <p>{newsContent}</p>
          </div>
          <Button
            iconAfter={<ArrowRight />}
            variant="subtle"
            size="S"
            onClick={() => navigate('/get-started/news/design-evolved')}
          >
            Read more
          </Button>
        </div>
      </div>
    </div>
  );
};

const LatestNewsStyled = styled(LatestNews)`
  margin-top: 2.5rem;

  .news-header {
    margin-bottom: 1.5rem;
  }

  h2 {
    color: ${({ theme }) => theme.neutralTextWeak};
    font-size: 2rem;
    font-weight: 300;
    line-height: 1.25;
    margin-top: 0;
    margin-bottom: 0;
  }

  img {
    max-width: 100%;
    border-radius: 0.75rem;
    height: 100%;
  }

  p {
    color: ${({ theme }) => theme.neutralTextWeak};
    margin-top: 0;
    margin-bottom: 1.5rem;
  }

  .news {
    &-body {
      align-items: center;
      display: grid;
      grid-template-columns: 1fr 3fr;
      gap: 1.5rem;
    }

    &-content {
      max-width: 39.5rem;
      margin-bottom: 1.5rem;
    }

    &-title {
      font-size: 1.25rem;
      font-weight: 400;
      line-height: 1.2;
      letter-spacing: -0.02em;
      margin-top: 0;
      margin-bottom: 0.75rem;
    }

    &-date {
      display: inline-block;
      color: ${({ theme }) => theme.neutralText};
      font-size: 0.75rem;
      font-weight: 500;
      line-height: 1;
      border: 0.0625rem solid ${({ theme }) => theme.neutralBorder};
      border-radius: 0.9375rem;
      padding: 0.5rem 0.75rem;
      margin-bottom: 0.75rem;
    }
  }
`;

export default LatestNewsStyled;
